import { TableContextMenuItem } from './table-context-menu-item';
import { ElementRef, HostListener, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, TemplateRef } from '@angular/core';
import { UserService } from './../../base-services/user.service';
import { ColumnData } from './../../base-models/column-data';
import { Component, OnInit, Input, Output, EventEmitter, IterableDiffer, IterableDiffers, SimpleChanges, KeyValueDiffers, KeyValueDiffer, ViewChild } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { NgbDropdown, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { CollectionService } from '../../base-services/collection.service';
import { PropertyBindingType } from '@angular/compiler';
import { Observable, Subject, Subscription } from 'rxjs';
import { List } from 'immutable';
import { ExportService } from '../../base-services/export.service';
import { AngularWaitBarrier } from 'blocking-proxy/built/lib/angular_wait_barrier';
import { TranslateService } from '@ngx-translate/core';
import { TableColumnsSum } from '../../base-models/table-columns-sum';
import { TableRowColor } from '../../base-models/table-row-color';
import { TableContextMenuContainerDirective } from './table-context-menu-container.directive';
import { TableContextMenu } from './table-context-menu';
import { CryptoService } from '../../base-services/crypto.service';

@Component({
  selector: 'yt-fw-default-table',
  templateUrl: './default-table.component.html',
  //styleUrls: ['./default-table.component.css']
  providers: [
    NgbDropdownConfig,
    CollectionService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultTableComponent implements OnInit, OnDestroy {

  private emittedSendExcel: Subject<any[]> = new Subject();
  // EmittedSendExcel: Observable<any[]> = this.emittedSendExcel.asObservable();
  // excelNiz: any[] = [];
  subscription: Subscription;

 

  constructor(
    private datePipe: DatePipe,
    private dropdownConfig: NgbDropdownConfig,
    private collectionService: CollectionService,
    //private iterableDiffers: IterableDiffers,
    private keyValueDiffers: KeyValueDiffers,
    private decimalPipe: DecimalPipe,
    public userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    public exportService: ExportService,
    private translateService: TranslateService
  ) { 
    dropdownConfig.placement = 'bottom-right';
    dropdownConfig.autoClose = true;
    //this.iterableDiffer = this.iterableDiffers.find(this.Items).create();
    this.userRights = this.userService.GetUserRights();
  }@ViewChild('searchBox', { static: false }) searchBoxComponent;

  @Input() tableTitle: string;

  @Input() extraButtonsTemplate: TemplateRef<any>;
  @Input() showInactive: boolean = false;

  @Output() ToggleShowInactiveClicked = new EventEmitter<void>();

  @Input() TableColumns: ColumnData[];
  @Input() TableColumnsSums: TableColumnsSum[];
  @Input('Items') set SetItems(items: List<any>) {
  // items.subscribe(items => {
  this.Items = items;
  this.originalItems = items;

  if (this.Items && this.Items.size > 0) {
    this.selectedItemIndex = 0;

    if (this.Items.find(item => item && item.Selected === true) != null) {
      this.inputSelectedItem = this.Items.find(item => item && item.Selected === true);
      this.Items
        .filter(item => item && item.Selected === true && item.ID != this.inputSelectedItem.ID)
        .forEach(item => item.Selected = false);
      this.changeDetectorRef.markForCheck();
      // this.SetSelectedItem(this.Items.find(item => item.Selected == true));
    }

    if (this.inputSelectedItem)
      this.selectedItemIndex = this.Items.indexOf(this.inputSelectedItem);

    this.keyValueDiffer = this.keyValueDiffers.find(this.Items).create();

    var key = (this.sortKey != null)
      ? this.sortKey
      : ((this.Config && this.Config.DefaultSortKey) ? this.Config.DefaultSortKey : null);

    if (key != null) {
      if (this.sortLabel == null) {
        var tableColumn = null;
        if (this.TableColumns && this.TableColumns.length) {
          tableColumn = this.TableColumns.find(function (column) {
            return column && column.Name == key;
          });
        }
        this.sortLabel = (tableColumn && tableColumn.Label)
          ? tableColumn.Label
          : ((key === 'ID' || (this.Config && this.Config.DefaultSortKey === 'ID')) ? 'unosu' : '');
      }

      this.SortItems(key, false, this.sortLabel || '');

      let item = null;
      if (this.inputSelectedItem == null)
        item = this.Items.get(this.selectedItemIndex);
      else
        item = this.Items.find(i => i && i.ID == this.inputSelectedItem.ID);

      if (item == null)
        item = this.Items.get(0);

      item.Selected = true;
      this.ItemActivated.emit(item);
      // this.Items = this.Items.set(this.selectedItemIndex, item);
      this.changeDetectorRef.markForCheck();
    }

    // this.SelectItem(this.Items[0]);
    // this.ItemActivated.emit(this.Items.get(0));
    // this.calculateSums();
  }

  this.calculateSums();
  // })
}

  //@Input() DefaultSortKey: string;
  //@Input() DefaultSortReverse: boolean;
  //@Input() set ItemsUpdated(value: boolean){
    //if(value)
      //this.SortItems(this.sortKey);
  //}
  @Input() showPagination: boolean = false;
  @Input() currentPage: number = 1;
  @Input() pageSize: number = 40;
  @Input() totalRecords: number = 0;

  @Input() Config: any;
  @Input() Condensed: boolean;
  @Input() ShowLoader: boolean;
  @Input() ButtonsDisabled: boolean = false;
  @Input() set KeyCode(value: number){
    // console.log('Default table keyCode: ' + value);
    if((value == 13 || value == 9) && this.Items && this.Items.count() > 0)
      this.SelectItem(this.Items.get(this.selectedItemIndex));
    else if(value == 38 || value == 40)
      this.setActiveItem(value);
  }
  @Input() set SetFilter(value: string){
    this.Filter(value ? value : '');
  }
  @Input() set SetSelectedItem(value){
    //this.SelectItem(value);
    this.inputSelectedItem = value;
    if(this.Items != null)
      this.Items.forEach(item => {
        item.Selected = false;
        if(value && (value['ID'] == item['ID']))
          item['Selected'] = true;
      })
      this.changeDetectorRef.markForCheck();
  }
  @Input() FilterByAllColumns: boolean = true;
  @Input() RowColors: TableRowColor[];
  @Input() set ScrollToView(value: boolean) {
    let _this = this;
    setTimeout(() => {
      let tableRect = _this.tableBody.nativeElement.getBoundingClientRect();
      let activeRow;
      let i;
      for(i = 0; i < this.tableBody.nativeElement.rows.length; i++)
        //if(this.tableBody.nativeElement.rows[i].className == 'table-active')
        if(this.tableBody.nativeElement.rows[i].className.indexOf('table-active') > -1)
          activeRow = this.tableBody.nativeElement.rows[i];
      if(activeRow){
        let rowRect = activeRow.getBoundingClientRect();
        let isViewable = (rowRect.top >= tableRect.top) && (rowRect.top <= tableRect.top + this.tableBody.nativeElement.clientHeight);
        if(!isViewable)
          this.tableBody.nativeElement.scrollTop = (rowRect.top + this.tableBody.nativeElement.scrollTop) - tableRect.top;
      }
      else{
        this.tableBody.nativeElement.scrollTop = 0;
      }
    }, 100)
  }

  @Input() ContextMenuItems: TableContextMenuItem[];
  @Input() ContextMenuOfTable: TableContextMenu[];

  Items: List<any>;
  footerItems;

  
  @Output() EditItemClicked = new EventEmitter();
  @Output() DeleteItemClicked = new EventEmitter();
  @Output() ItemCheckClicked = new EventEmitter();
  @Output() ItemSelected = new EventEmitter();
  @Output() AddItemClicked = new EventEmitter();
  @Output() DeleteItemsClicked = new EventEmitter();
  @Output() RefreshDataClicked = new EventEmitter();
  @Output() PrintClicked = new EventEmitter();
  @Output() ItemActivated = new EventEmitter();
  @Output() DetailTableVisibilityChanged = new EventEmitter();
  @Output() PrintItemClicked = new EventEmitter();
  @Output() ColumnsRatioChanged = new EventEmitter();
  @Output() ContextMenuItemClicked = new EventEmitter();
  @Output() SelectItemFormatDetailClicked = new EventEmitter();
  
  @Output() pageChanged = new EventEmitter<number>();
  currentRatio: number = 6; // default je 1:1

  @Output() ContextMenuOfTableClicked = new EventEmitter();

  filter: string;
  originalItems: List<any>;
  sortReverse: boolean;
  sortKey: string;
  sortLabel: string
  //iterableDiffer: IterableDiffer<any>;
  checkAll: boolean = false;
  keyValueDiffer: KeyValueDiffer<any, any>;
  private selectedItemIndex: number = 0;
  defaultTableName: number = parseInt((Math.random() * 100).toFixed(0));
  inputSelectedItem;
  detailTableVisible: boolean = true;
  userRights;
  brojContextMenu: number;
  brojContextMenuOfTable: number;

  //searchText: string;
  //sortKey: string;
  //sortReverse: boolean;

  @ViewChild('table', { static: true }) table: ElementRef;
  @ViewChild('tbody', { static: true }) tableBody: ElementRef;
  @ViewChild('thead', { static: false }) tableHead: ElementRef;
  @ViewChild('tfooter' , { static: false }) tableFooter: ElementRef;
  @ViewChild(TableContextMenuContainerDirective, { static: false }) tableContextMenuContainer: TableContextMenuContainerDirective;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event){
    //console.log(event);
  }
  loaderReady = false;

  ngOnInit() {
  this.sortReverse = (this.Config && typeof this.Config.DefaultSortReverse === 'boolean')
  ? this.Config.DefaultSortReverse
  : this.sortReverse;

this.sortKey = (this.sortKey != null)
  ? this.sortKey
  : (this.Config && this.Config.DefaultSortKey ? this.Config.DefaultSortKey : null);

if (this.TableColumns && this.TableColumns.length && this.sortKey != null && this.sortLabel == null) {
  var keyInit = this.sortKey != null ? this.sortKey : (this.Config ? this.Config.DefaultSortKey : null);
  var colInit = this.TableColumns.find(function (c) { return c && c.Name == keyInit; });
  this.sortLabel = (colInit && colInit.Label)
    ? colInit.Label
    : ((keyInit === 'ID' || (this.Config && this.Config.DefaultSortKey === 'ID')) ? 'unosu' : '');
}


    this.subscription = this.emittedSendExcel.subscribe(niz =>
      {
        // this.exportService.exportAsExcelFile(niz, this.translateService.get(this.Config.BreadCrumble)["value"]);

        this.translateService.get([this.Config.BreadCrumble])
        .subscribe(translate =>{
          this.exportService.exportAsExcelFile(niz, translate[this.Config.BreadCrumble]);
        })
      })

      if(this.ContextMenuItems)
      this.brojContextMenu = this.ContextMenuItems.length;

      if(this.ContextMenuOfTable)
      this.brojContextMenuOfTable = this.ContextMenuOfTable.length;

      this.loadTableSettingsFromStorage();
  }

  ngDoCheck(){
    //alert('erwer');
    //this.SortItems(this.sortKey);
    //if(this.Items){
    //this.iterableDiffer = this.iterableDiffers.find(this.Items).create(null);
    //let changes = this.iterableDiffer.diff(this.Items);
    if(!this.keyValueDiffer && this.Items)
      this.keyValueDiffer = this.keyValueDiffers.find(this.Items).create();
    if(this.Items && this.Items.size > 0 && this.keyValueDiffer){
      let changes = this.keyValueDiffer.diff(this.Items);
    //changes.forEachAddedItem((item) => this.SortItems(this.sortKey));
    if(changes)
      this.SortItems(this.sortKey ? this.sortKey : this.Config.DefaultSortKey, false, this.sortLabel);
    //this.SelectItem(this.Items[this.selectedItemIndex]);
    }
    //}
  }

ngOnChanges(changes: SimpleChanges){
  if (changes['TableColumns']) {
    var key = (this.sortKey != null)
      ? this.sortKey
      : ((this.Config && this.Config.DefaultSortKey) ? this.Config.DefaultSortKey : null);

    if (key != null && this.TableColumns && this.TableColumns.length && !this.sortLabel) {
      var col = this.TableColumns.find(function (c) { return c && c.Name == key; });
      this.sortLabel = (col && col.Label)
        ? col.Label
        : ((key === 'ID' || (this.Config && this.Config.DefaultSortKey === 'ID')) ? 'unosu' : '');
    }
  }
}


  ngAfterViewChecked(){
    //console.log('table: ' + this.table.nativeElement.offsetHeight);
    //this.tableBody.nativeElement.style.height = this.table.nativeElement.style.height.substring(0, this.table.nativeElement.style.height.indexOf('px')) - 
          //(this.tableHead ? (this.tableHead.nativeElement.clientHeight > 0 ? this.tableHead.nativeElement.clientHeight : 37) : 0) - 
          //(this.tableFooter ? (this.tableFooter.nativeElement.clientHeight > 0 ? this.tableFooter.nativeElement.clientHeight : 22) : 0) + 'px';
    //this.changeDetectorRef.markForCheck();
    //console.log(this.defaultTableName + 'tableBody height: ' + this.tableBody.nativeElement.style.height);
    //console.log(this.defaultTableName + 'tableHead height: ' + this.tableHead.nativeElement.style.height + ' ' + this.tableHead.nativeElement.clientHeight);
    //console.log('tbody: ' + this.tableBody.nativeElement.style.height);
    //console.log('default table ngAfterViewChecked' + new Date());
    //this.calculateHeight();

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.calculateHeight();
      this.loaderReady = true; 
      this.changeDetectorRef.markForCheck(); 
    }, 1000); 
  }
  
  calculateHeight(){
    if (this.Config && this.Config.IsModal) {
      const maxHeight = 400; 
      const tableHeadHeight = (this.tableHead && this.tableHead.nativeElement && this.tableHead.nativeElement.clientHeight)
        ? this.tableHead.nativeElement.clientHeight
        : 37;
  
      const tableFooterHeight = (this.tableFooter && this.tableFooter.nativeElement && this.tableFooter.nativeElement.clientHeight)
        ? this.tableFooter.nativeElement.clientHeight
        : 22;
  
      const calculatedBodyHeight = maxHeight - tableHeadHeight - tableFooterHeight;
  
      this.tableBody.nativeElement.style.maxHeight = calculatedBodyHeight + 'px';
      this.tableBody.nativeElement.style.overflowY = 'auto';
      return;
    }
    this.tableBody.nativeElement.style.height = this.table.nativeElement.style.height.substring(0, this.table.nativeElement.style.height.indexOf('px')) -
      (this.tableHead ? (this.tableHead.nativeElement.clientHeight > 0 ? this.tableHead.nativeElement.clientHeight : 37) : 0) -
      (this.tableFooter ? (this.tableFooter.nativeElement.clientHeight > 0 ? this.tableFooter.nativeElement.clientHeight : 22) : 0) + 'px';
 
    
  }

  EditItem(ID){
    this.EditItemClicked.emit(ID);
  }

  DeleteItem(ID){
    this.DeleteItemClicked.emit(ID);
  }

  GetPropertyValue(item, property, type, format){
    if(property.indexOf('.') == -1)
      return this.getValue(item[property], type, format);
    else
      return this.GetPropertyValue(item[property.split('.')[0]], property.split('.')[1], type, format);
  }

  SortItems(sortKey: string, revert: boolean, sortLabel: string){
    //this.Items = this.Items.sort((val1, val2) => {
      //if (val1.ID < val2.ID) return 1;
      //if (val1.ID > val2.ID) return -1;
      //return 0;
    //})
    this.sortKey = sortKey;
    this.sortLabel = sortLabel;
    if(revert)
      this.sortReverse = !this.sortReverse;
    this.Items = this.collectionService.SortItems(this.Items, sortKey, this.sortReverse);
    //this.sortReverse = !this.sortReverse;
  }

  Filter(filter){
    if(filter != null){
      this.Items = this.collectionService.FilterItems(this.originalItems, filter, this.FilterByAllColumns ? '' : this.sortKey, this.TableColumns);
      if(this.Items && this.Items.size > 0){ 
        this.ItemActivated.emit(this.Items[0]);
      }
      else{
         this.ItemActivated.emit(null);
      }
      this.selectedItemIndex = 0;

      if(this.Items)
        this.Items.forEach(item => {
          item.Selected = false;
        })
      if(this.Items && this.Items.size > 0)
        this.Items.get(0).Selected = true;

      if((filter == '') && this.Items){
        this.Items.forEach(item => {
          item.Selected = false
        });
        //this.Items.get(0).Selected = true;
        if(this.inputSelectedItem){
          // this.Items.find(item => item.ID == this.inputSelectedItem.ID).Selected = true;
          const itemFind = this.Items.find(item => item.ID == this.inputSelectedItem.ID);
          if (itemFind != undefined)
            itemFind.Selected = true;
        }
        this.ScrollToView = true;
      }
    }
  }

  GetTableOptionsButtonColspan(){
    let visibleColumnsCount = 0;
    this.TableColumns.forEach((column: ColumnData) => {
      if(column.Visible)
        visibleColumnsCount++;
    })

    //return 2 + (this.TableColumns.length - visibleColumnsCount);
    return visibleColumnsCount > 0 ? 3 : 4;
  }

  HasVisibleColumns(){
    let hasVisibleColumns = false;
    this.TableColumns.forEach((column: ColumnData) => {
      if(column.Visible)
        hasVisibleColumns = true;
    })
    return hasVisibleColumns;
  }

  CheckItem(item){
    this.ItemCheckClicked.emit({ ID: item.ID, isChecked: item.Checked});
  }

  CheckAll(){
    this.Items.forEach(item => {
      item.Checked = this.checkAll;
      this.CheckItem({ ID: item.ID, Checked: this.checkAll});
    })
  }

  SelectItem(item){
    if(item === null || item == undefined){
      item = this.Items.get(0);
    }
    
    this.ItemSelected.emit(item);
    this.Items.forEach(value => {
      value.Selected = false;
    })

    if(item){
      item.Selected = true;
    }

    this.SelectItemFormatDetailClick(item);
  }

  private getValue(propertyValue, type: string, format: string){
    if(propertyValue == null)
      return null;
    if(propertyValue === '')
      return '';
    switch(type){
      case 'text': return propertyValue;
      case 'datetime': return this.datePipe.transform(propertyValue, format, '', this.userService.GetLocaleString());
      case 'number': return this.decimalPipe.transform(propertyValue, format, this.userService.GetLocaleString());
      case 'date': return this.datePipe.transform(propertyValue, format);
      case 'ngbDate': return this.datePipe.transform(new Date(propertyValue.year.toString() + '/' + propertyValue.month.toString() + '/' + propertyValue.day.toString()), format);
      case 'boolean': return (propertyValue == true ? "<span class='fa fa-fw fa-check'></span>" : '')
      case 'booleanX': return (propertyValue == false ? "<span class='fa fa-fw fa-times'></span>" : '')
      default: return propertyValue;
    }
  }

  AddItem(){
    console.log('DefaultTableComponent:'+ "AddItem");
    this.AddItemClicked.emit();
  }

  DeleteItems(){
    this.DeleteItemsClicked.emit();
  }

  private setActiveItem(value: number){
    if(value == 40 && this.Items != null && this.Items.size > 0){
      if(this.selectedItemIndex + 1 <= this.Items.size - 1){
        this.selectedItemIndex++;
        if(this.selectedItemIndex > this.Items.size - 1)
          this.selectedItemIndex = this.Items.size - 1;
          //document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).scrollIntoView({block: 'end', inline: 'nearest', behavior: 'smooth'});
          document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).parentElement.scrollTop = document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).offsetTop;
      }
    }
    else if(value == 38 && this.Items != null && this.Items.size > 0){
      this.selectedItemIndex--;
      if(this.selectedItemIndex < 0)
        this.selectedItemIndex = 0;
        //document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
        document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).parentElement.scrollTop = document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).offsetTop;
    }

    //for(let i:number = 0;i < this.Items.size; i++){
      //this.Items[i]['Selected'] = false;
      //if(i == this.selectedItemIndex)
        //this.Items[i]['Selected'] = true;
        ////this.ItemActivated.emit(this.Items[i]);
    //}
    if(this.Items != null && this.Items.size > 0){
      this.Items.filter(item => item.Selected == true).forEach(item => item.Selected = false);
      let tempItem = this.Items.get(this.selectedItemIndex);
      if(tempItem == null){
        //tempItem = this.Items.get(0);
        this.selectedItemIndex = 0;
        tempItem = this.Items.get(this.selectedItemIndex);
      }
      tempItem.Selected = true;
      this.changeDetectorRef.markForCheck();
    }
    
  }

  RefreshData(){
    this.RefreshDataClicked.emit();
  }

  Print(){
    this.PrintClicked.emit();
  }
  private currentlyOpen: NgbDropdown | null = null;

  toggleDropdown(dropdownToToggle: NgbDropdown): void{
    if (this.currentlyOpen === dropdownToToggle) {
      this.currentlyOpen = null;
      return;
    }

        if (this.currentlyOpen) {
          this.currentlyOpen.close();
        }
    this.currentlyOpen = dropdownToToggle;
  }

hideDetailTableToggle(){
  this.detailTableVisible = !this.detailTableVisible;
  this.DetailTableVisibilityChanged.emit(this.detailTableVisible);
  this.saveTableSettingsToStorage();
}


  PrintItem(item){
    this.PrintItemClicked.emit(item.ID);
  }

  ExportToExcel(){
    let niz = [];
    this.SortItems(this.sortKey ? this.sortKey : this.Config.DefaultSortKey, false, this.sortLabel);
    this.Items.forEach(item => {
        niz.push(
          Object.assign({}, item)
        )
      })
      if(this.footerItems)
        this.footerItems.forEach(footerItem => {
          niz.push(Object.assign({}, footerItem))
        })


   
    niz.forEach(item => {
      Object.keys(item).forEach(property => {
        let exists = false;
         this.TableColumns.forEach(column => {
         if(property == column.Name){
           if(column.Type=="ngbDate"){
            item[column.Name] = this.getValue(item[column.Name], column.Type, column.Format);    
           }
            exists = true;
          }
         })
         if(!exists)
           delete item[property];
       })
     })

     this.emittedSendExcel.next(niz);

    
     
      //return this.emittedSendExcel.asObservable();

    // let _this = this;
    // setTimeout(function(){
    // console.log('Export: ' + new Date());
    //   _this.exportService.exportAsExcelFile(niz, 'sample');
    // }, 2000);
    
  }
  ngOnDestroy(){
    this.subscription.unsubscribe();
    if (this.currentlyOpen) {
      this.currentlyOpen.close();
    }
  }

  calculateSums(){
    if(this.TableColumnsSums){
      this.footerItems = [];
      this.TableColumnsSums.forEach(tableColumnsSum => {
        if(this.Items != null){
        let sum = this.Items.reduce((acc, cur) => {
          for(let key in cur){
            if(tableColumnsSum.Columns.indexOf(key) > -1){
              if(acc[key] == null)
                acc[key] = 0;
              //if(acc[key])
                acc[key] += cur[key] != null && cur[key] != '' && (tableColumnsSum.Condition ? tableColumnsSum.Condition.IsSatisfied(cur) : true) ? cur[key] : 0;
            }
            else{
              acc[key] = '';
            }
          }
          return acc;
        }, {});
        if(this.footerItems == null)
          this.footerItems = [];
        sum[this.TableColumns[0].Name] = 'Ukupno';
        this.footerItems.push(sum);
      }
      })     
      setTimeout(() => {
        this.calculateHeight();
      }, 100)
    }
  }

setColumnsRatio(ratio: number, save: boolean = true): void {
  this.currentRatio = ratio;
  this.ColumnsRatioChanged.emit('col-md-' + ratio);

  setTimeout(() => {
    this.changeDetectorRef.detectChanges(); 
  });

  if (save) this.saveTableSettingsToStorage();
}


  createContextMenu(){
  }

  ContextMenuItemClick(contextMenuItem: TableContextMenuItem, ID: number){
    contextMenuItem.ID = ID;
    this.ContextMenuItemClicked.emit(contextMenuItem);
  }

  ContextMenuOfTableClick(contextMenuOfTable: TableContextMenu){
    this.ContextMenuOfTableClicked.emit(contextMenuOfTable);
  }

  SelectItemFormatDetailClick(item : any){
    this.SelectItemFormatDetailClicked.emit(item);
  }
    
  onPageChanged(newPage: number) {
    this.pageChanged.emit(newPage);
  }
  
  get hasToggleShowInactiveListener(): boolean {
    return this.ToggleShowInactiveClicked.observers.length > 0;
  }

saveTableSettingsToStorage(): void {
  const key = 'defaultTable_' + this.getUserId() + '_' + this.Config.BreadCrumble;
  const settings = {
    columns: this.TableColumns
      .filter(col => col.CanHide)
      .map(col => ({ name: col.Name, visible: col.Visible })),
    ratio: this.currentRatio,
    detailVisible: this.detailTableVisible
  };
  localStorage.setItem(key, JSON.stringify(settings));
}

loadTableSettingsFromStorage(): void {
  const key = 'defaultTable_' + this.getUserId() + '_' + this.Config.BreadCrumble;
  const stored = localStorage.getItem(key);
  if (stored) {
    const parsed = JSON.parse(stored);

    if (parsed.columns) {
      this.TableColumns.forEach(col => {
        const saved = parsed.columns.find(c => c.name === col.Name);
        if (saved) col.Visible = saved.visible;
      });
    }

    if (parsed.ratio) {
      setTimeout(() => this.setColumnsRatio(parsed.ratio, false));
    }

    if (typeof parsed.detailVisible !== 'undefined') {
      this.detailTableVisible = parsed.detailVisible;
    }
  }
}

toggleColumnVisibility(column): void {
  column.Visible = !column.Visible;
  this.saveTableSettingsToStorage();
}

private getUserId(): string {
  const decryptedUserData = CryptoService.Decrypt(sessionStorage.getItem('sel-user'));
  return (decryptedUserData && decryptedUserData.UserID != null)
    ? decryptedUserData.UserID.toString()
    : '0';
}

public ClearSearchBox() {
  if (this.searchBoxComponent) {
    this.searchBoxComponent.onClearClick();
  }
}
}